<template>
  <div class="GdPage">
    <div class="back" @click="goBack()">
      <div class="backIcon">
        <img src="../../assets/images/workOrderReview/back.png" alt="">
      </div>
      <div class="backText">{{$t('lang.UploadProof.backText')}}</div>
    </div>

      <Loadmore
        :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
        :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
        :bottomLoadingText="$t('lang.loadingStatus.loading')"
        :auto-fill="false"
        :bottom-method="getList"
        :bottom-all-loaded="hasLoadAll"
        ref="loadmore">
        <div class="listView" id="listView">
      <div class="listItem" v-for="(item,index) in list" :key="index" @click="checkedItem(item.TransactionUuid)">
        <div class="checkBox">
          <div class="checked" v-if="item.checked"></div>
          <div class="check" v-else></div>
        </div>
        <div class="itemBox">
          <div class="row">
            <div class="left">
              <img class="wallet" src="../../assets/images/workOrderReview/wallet.png" alt="">
              <div class="typeTitle" v-if="item.Type === 'deposit'">{{$t('lang.UploadProof.Deposit')}}</div>
              <div class="typeTitle" v-if="item.Type === 'withdrawal'">{{$t('lang.UploadProof.Withdraw')}}</div>
              <div class="copyId" @click="copyId(item.TransactionUuid)">{{$t('lang.UploadProof.CopyId')}}</div>
            </div>
            <div class="right">
              <div class="statusDone" v-if="item.Status==='done'">{{$t('lang.UploadProof.Done')}}</div>
              <div class="statusProcessing" v-if="item.Status==='processing'">{{$t('lang.UploadProof.Processing')}}</div>
              <div class="statusRejected" v-if="item.Status==='rejected'">{{$t('lang.UploadProof.Rejected')}}</div>
              <div class="statusProcessing" v-if="item.Status==='awaiting approval'">{{$t('lang.UploadProof.Processing')}}</div>
              <div class="value">₹{{item.Amount}}</div>
            </div>
          </div>
          <div class="row">
            <div class="left">
              <div class="time">{{item.TransactionDate}}</div>
            </div>
            <div class="right">
              <div class="balance">{{$t('lang.UploadProof.Balance')}}:₹{{item.TotalBalance}}</div>
            </div>
          </div>
        </div>
      </div>
        <div class="showMore" v-if="!hasLoadAll"><img :src="showMore" alt=""></div>
        </div>
      </Loadmore>

    <div class="btnBox">
      <div @click="goto()" v-if="checkedItemData" class="next">{{$t('lang.UploadProof.Next')}}</div>
      <div  v-else class="nextNo">{{$t('lang.UploadProof.Next')}}</div>
    </div>

  </div>
</template>

<script>
import {Loadmore, Toast} from 'mint-ui'
import request from '@/service'
// import {Toast} from 'mint-ui'
import showMore from '@/assets/images/common/showMore.gif'
// eslint-disable-next-line no-unused-vars
let initialData = {
  Skip: 0,
  Take: 10,
  check: 0,
  list: [],
  hasLoadAll: true,
  firstLoad: true,
  showMore,
  checkedItemData: null,
  lastCheckedUuid: null // 用于存储上一次选中的 TransactionUuid
}
export default {
  name: 'workOrderReview',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.Skip = 0
      vm.Take = 10
      vm.check = 0
      vm.list = []
      vm.hasLoadAll = true
      vm.firstLoad = true
      vm.checkedItemData = null
      vm.lastCheckedUuid = null // 用
      vm.getList()
    })
  },
  data () {
    return {
      Skip: 0,
      Take: 10,
      check: 0,
      list: [],
      hasLoadAll: true,
      firstLoad: true,
      showMore,
      checkedItemData: null,
      lastCheckedUuid: null // 用于存储上一次选中的 TransactionUuid
    }
  },
  watch: {
    '$store.state.locale': function () {

    }
  },
  components: {
    Loadmore
  },
  mounted () {
    // this.getList()
  },
  methods: {
    checkedItem (TransactionUuid) {
      // 如果有上一次选中的项，则取消选中
      if (this.lastCheckedUuid) {
        const lastCheckedItem = this.list.find(item => item.TransactionUuid === this.lastCheckedUuid)
        if (lastCheckedItem) {
          lastCheckedItem.checked = false
        }
      }

      // 找到当前选中的项并更新状态
      const currentItem = this.list.find(item => item.TransactionUuid === TransactionUuid)
      if (currentItem) {
        currentItem.checked = true
        this.checkedItemData = currentItem
      }

      // 更新上一次选中的 TransactionUuid
      this.lastCheckedUuid = TransactionUuid
    },
    getList () {
      let url = '/innovation/ticket/payment/list'
      let data = {
        Type: sessionStorage.getItem('ProofType') === 'D' ? 'deposit' : 'withdrawal',
        TicketStatus: this.TicketStatus,
        Skip: this.Skip,
        Take: this.Take,
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, false).then(res => {
        if (res) {
          res.Transactions.forEach(item => {
            item.checked = false
          })
          if (this.check > 0) {
            this.list = res.Transactions
          } else {
            this.list = this.list.concat(res.Transactions)
          }
          this.Skip += this.Take
          this.hasLoadAll = this.Skip >= res.Total
          if (!this.firstLoad) {
            this.$refs.loadmore.onBottomLoaded()
          }
          this.firstLoad = false
          this.check = 0
        }
      }).catch(err => {
        console.log(err)
      })
    },
    copyId (id) {
      // 进行复制
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', id)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    goBack () {
      sessionStorage.removeItem('ProofType')
      this.Skip = 0
      this.Take = 10
      this.check = 0
      this.list = []
      this.hasLoadAll = true
      this.firstLoad = true
      this.checkedItemData = null
      this.lastCheckedUuid = null // 用
      this.$router.back()
    },
    isFiveHoursLater (dateTimeStr) {
      // 将传入的日期时间字符串转换为Date对象
      const givenDate = new Date(dateTimeStr)
      // 获取当前时间的Date对象
      const now = new Date()

      // 计算两个时间的差值（以毫秒为单位）
      const timeDiff = Math.abs(now - givenDate)

      // 将毫秒转换为小时
      const hoursDiff = timeDiff / (1000 * 60 * 60)

      // 判断时间差是否大于3小时
      return hoursDiff > 3
    },
    goto () {
      if (!this.isFiveHoursLater(this.checkedItemData.TransactionDate)) {
        Toast(this.$t('lang.workOrderReview.FiveHoursLater'))
        return
      }
      sessionStorage.setItem('TransactionData', JSON.stringify(this.checkedItemData))
      sessionStorage.setItem('DetailShowType', 0)
      if (sessionStorage.getItem('ProofType') === 'D') {
        this.$router.push('UploadproofDepositDetail')
      } else if (sessionStorage.getItem('ProofType') === 'W') {
        this.$router.push('UploadproofWithdrawDetail')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.GdPage {
  position: relative;
  top: -10px;
  height: 80vh;
  .back{
    height: 6.11vw;
    display: flex;
    align-items: center;
    margin-top: 22vw;

    .backIcon{
      margin-left: 5vw;

    }
    .backText{
      margin-left: 5vw;
      color: #F6D9AA;
      font-weight: 700;
      font-size: 5.27vw;
    }
  }
  .btnBox{
    height: 20vw;
    //border: 1px solid red;
    display: flex;
    justify-content: center;
    align-items: center;
    .next{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #F6D9AA;
      color: #000;
      font-size: 4.166vw;
      width: 87.761vw;
      height: 11.111vw;
      border-radius: 1.11vw;
    }
    .nextNo{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #4F4F4F;
      color: #9a9a9a;
      font-size: 4.166vw;
      width: 87.761vw;
      height: 11.111vw;
      border-radius: 1.11vw;
    }
  }
  .listView{
    margin-top: 7vw;
    //border: 1px solid red;
    height: 73vh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
    .listItem{
      width: 92.708vw;
      height: 13.611vw;
      //border: 1px solid red;
      margin-bottom: 3vw;
      flex: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .checkBox{
          user-select: none;
        .check{
          height: 3.188vw;
          width: 3.188vw;
          background: #fff;
          border-radius: 3vw;
          flex: none;
        }
        .checked{
          background: #096BA8;
          height: 3.188vw;
          width: 3.188vw;
          border: 0.8vw solid #fff;
          border-radius: 3vw;
          flex: none;
        }
      }
      .itemBox{
        width: 87.286vw;
        height: 13.611vw;
        background: #242424;
        border-radius: 3vw;
        padding: 0 3vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 3vw;
        gap:2.1vw 0;
        .row{
          display: flex;
          justify-content: space-between;
          //border: 1px solid red;
          .left{
            display: flex;
            align-items: center;
            flex: 1;
            .wallet{}
            .typeTitle{
              margin-left: 2vw;
              font-size: 4.1666vw;
              color: #fff;
            }
            .copyId{
              color: #3EA4DD;
              margin-left: 1.2vw;
              border-bottom: 1px solid #3EA4DD;
              font-size: 2.5vw;
              position: relative;
              top: -0.7vw;
            }
            .time{
              color: #DBDBDB;
              opacity: .47;
            }
          }
          .right{
            flex: 1;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            //border: 1px solid red;
            margin-left: 7vw;
            .statusProcessing{
              background: #C11C06;
              color: #FFFFFF;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 0.55vw;
              padding: 0.6vw 2vw;
            }
            .statusDone{
              background: #006723 ;
              color: #000;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 0.55vw;
              padding: 0.6vw 2vw;
            }
            .statusRejected{
              background: #91000E;
              color: #000;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 0.55vw;
              padding: 0.6vw 2vw;
            }
            .value{
              margin-left: 1vw;
              color: #FFFFFF;
              font-size: 3.44vw;
              font-weight: 700;
            }
            .balance{
              color: #DBDBDB;
              opacity: .47;
            }
          }
        }
      }
    }
  }
}
.showMore {
  text-align: center;

  img {
    width: 2.777vw;
  }
}
.mint-loadmore{
  padding-top: 2vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/workOrderReview/Uploadproof.vue